import React from 'react';
import { Link } from 'react-router-dom';
import './register-modal.css';

const RegisterInfoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="register-modal-overlay">
      <div className="register-modal">
        <button className="modal-close-btn" onClick={onClose}>×</button>
        
        <div className="modal-header">
          
          <h2>திருமண சேவைக்கு வரவேற்கிறோம்</h2>
        </div>
        
        <div className="modal-content">
          <div className="modal-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#e84393" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 16V12" stroke="#e84393" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 8H12.01" stroke="#e84393" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <div className="modal-message">
            <p className="message-title">எங்கள் அலுவலகத்தில் முன்னதாகவே பதிவு செய்துள்ளீர்களா?</p>
            <p className="message-content">
              உங்கள் பதிவு செய்யப்பட்ட <span className="highlight-text">தொலைபேசி எண்ணை</span> பின்வருமாறு பயன்படுத்தி நேரடியாக உள்நுழையலாம்:
            </p>
            <div className="login-instructions">
              <div className="instruction-item">
                <span className="instruction-label">பயனர்பெயர் (User ID):</span>
                <span className="instruction-value">தொலைபேசி எண்</span>
              </div>
              <div className="instruction-item">
                <span className="instruction-label">கடவுச்சொல் (Password):</span>
                <span className="instruction-value">தொலைபேசி எண்</span>
              </div>
            </div>
          </div>
          
          <div className="modal-info-list">
            <div className="info-item">
              <span className="info-icon">✓</span>
              <span>உங்கள் பதிவு செய்யப்பட்ட தொலைபேசி எண்ணைப் பயன்படுத்தி உள்நுழையவும்</span>
            </div>
            <div className="info-item">
              <span className="info-icon">✓</span>
              <span>உங்கள் சேமித்த சுயவிவரங்கள் மற்றும் பொருத்தங்களை அணுகவும்</span>
            </div>
            <div className="info-item">
              <span className="info-icon">✓</span>
              <span>உங்கள் வாழ்க்கைத் துணை தேடல் பயணத்தைத் தொடரவும்</span>
            </div>
          </div>
          
          <div className="modal-actions">
           
            <button onClick={onClose} className="modal-register-btn">
             Thank you
            </button>
          </div>
        </div>
        
        <div className="modal-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
        </div>
      </div>
    </div>
  );
};

export default RegisterInfoModal;
